
import { Slide } from '@hokify/hooper';
import type {
	IAPIFeatureAdvertisementSimple,
	IAPIFeatureAdvertisementExtended
} from '@hokify/common';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import HokCarousel from './HokCarousel.vue';
import { lsTest } from '../helpers/localstorage';

export default defineComponent({
	name: 'FeatureAdvertisement',
	components: {
		Slide,
		HokCarousel
	},
	data() {
		return {
			currentSlide: 0
		};
	},
	computed: {
		featureAdvertisementShown(): boolean {
			return (
				lsTest() &&
				localStorage.getItem(`advertisementShown-${this.features?._id}`) === this.features._id
			);
		}
	},
	methods: {
		handleCloseModal() {
			if (lsTest()) {
				localStorage.setItem(`advertisementShown-${this.features?._id}`, this.features?._id);
			}
			this.trackAdClick();
			this.$modal.hide('feature-advertisement');
			this.$emit('closed-feature-ad');
		},
		handleSlide(payload: { currentSlide: number }) {
			this.currentSlide = payload.currentSlide;
		},
		clickFeature(button: { text: string; outline: boolean; url?: string }) {
			// if no url is specified the button is used to close the modal
			if (!button.url) {
				this.handleCloseModal();
			} else {
				if (lsTest()) {
					localStorage.setItem(`advertisementShown-${this.features?._id}`, this.features?._id);
				}
				this.trackAdClick(button.url);
			}
		},
		trackAdClick(url?: string) {
			this.$trackGenericEvent('click_feature_ad', {
				featureId: this.features?._id,
				pageElement: this.features?.mainUrl,
				url: url || 'closed'
			});
		}
	},
	props: {
		features: {
			type: Object as PropType<IAPIFeatureAdvertisementSimple | IAPIFeatureAdvertisementExtended>,
			required: true
		},
		usedApp: { type: String, default: 'user' },
		lazy: { type: Number, default: 1 },
		clickToClose: { type: Boolean, default: false }
	}
});
